import React from 'react';
import '../asset/policy.css'
import { Grid, Header, Container, Divider } from 'semantic-ui-react'

export default function Policy(){
    return(
        <Grid id="gridHome">
        <Grid.Row id="gridHead">
            <Header id="fontHeaderPolicy">Privacy Policy</Header>
            <Header id="fontHeaderThai">นโยบายคุ้มครองความเป็นส่วนตัว</Header>
        </Grid.Row>
        <Grid.Row>
            <Grid.Column id="gridDetailPolicy">
            <Container id="containnerPolicy" >
                {/* <Header as='h2'>นโยบายคุ้มครองความเป็นส่วนตัว</Header> */}
                <label id="fontPolicy">
                ทางทีมผู้พัฒนาได้พัฒนาแอปพลิเคชั่น “ Pick AT Home” ขึ้นมา สามารถใช้ได้ฟรี 
                เราได้ทำการจัดทำนโยบายนี้ขึ้นมาเพื่อให้ข้อมูลกับผู้ใช้งานแอปพลิเคชั่นได้ทราบเกี่ยวกับการเก็บข้อมูลส่วนบุคคล 
                การนำข้อมูลเหล่านี้ไปใช้ และสิทธิในข้อมูลส่วนบุคคลของท่าน
                นโยบายคุ้มครองความเป็นส่วนตัวฉบับนี้มีผลนับตั้งแต่วันที่ 15 เมษายน 2021
                </label>
            </Container>  
            <Container id="containnerPolicy">
                <Header as='h2' id="fontHeaderThai">ข้อมูลส่วนบุคคลของผู้ใช้งานที่เราเก็บ</Header>
                <label id="fontPolicy">
                ข้อมูลส่วนบุคคลตามที่คุณได้กรอกเพื่อทำการสมัครสมาชิกกับเรา
                แอปพลิเคชั่นของเราจะไม่ทำการเผยแพร่ข้อมูลส่วนบุคคลของคุณให้กับบุคคลอื่นนอก
                เหนือจากที่ระบุในนโยบายคุ้มครองความเป็นส่วนตัวฉบับนี้
                </label>
            </Container>    
            <Container id="containnerPolicy">
                <Header as='h2' id="fontHeaderThai">เราเก็บข้อมูลของท่านเพื่อจุดประสงค์ในด้านใด</Header>
                <label id="fontPolicy">
                เพื่ออำนวยความสะดวกในการใช้งานครั้งถัดไป
                เพื่อให้เกิดความสะดวกในการใช้งานของท่าน ท่านไม่จำเป้นต้องทำการสมัครเพื่อเข้าใช้งานทุกรอบที่ใช้บริการของเรา และยังสามารถตรวจสอบประวัติการทำรายการของท่านได้ตลอดเวลา
                และเพื่อนำไปพัฒนาแอปพลิเคชั่นให้มีประสิทธิภาพมากยิ่งขึ้น
                สำหรับข้อมูลที่ถูกเก็บไปดังที่กล่าวข้างต้น 
                เราจะนำข้อมูลไปวิเคราะห์เพื่อพัฒนาเครื่องมืออำนวยความสะดวกต่างๆเพิ่มเติม 
                รวมไปถึงทำการปรับปรุงเครื่องมือเก่าเพื่อให้ท่านมีประสบการณ์ที่ดียิ่งขึ้นในการใช้งานแอปพลิชั่นของเรา
                </label>
            </Container>    
            <Container id="containnerPolicy">
                <Header as='h2' id="fontHeaderThai">การเปลี่ยนแปลงนโยบายคุ้มครองความเป็นส่วนตัว</Header>
                <label id="fontPolicy">
                เราอาจทำการเปลี่ยนแปลงนโยบายคุ้มครองความเป็นส่วนตัวในอนาคตเพื่อให้สอดคล้องกับแนวทางปฎิบัติ และกฏหมายข้อบังคับที่เกี่ยวข้อง หากมีการเปลี่ยนแปลงเกิดขึ้น เราจะทำการแจ้งให้ท่านทราบผ่านข้อมูลการ
                </label>
            </Container>        
            </Grid.Column>
        </Grid.Row>
    </Grid>
    )
}